import { _sharedActionsConstantsSystem } from "../system/actions";
import { _sharedActionsConstantsLibrary } from "./actions";

export const _sharedStateLibrary = {
  allHistory: [],
  allHistoryUserId: null,
};

export const _sharedReducerLibrary = (state, action) => {
  switch (action.type) {
    case _sharedActionsConstantsSystem.SET_IS_LOGIN: {
      // doubtful, probably need to remove history items on login to another account,
      // but before
      // need to split all history object to [ML | Basic | Local] separated history objects.
      if (action.data === true) {
        return state;
      }

      return {
        ...state,
        ..._sharedStateLibrary,
      };
    }
    case _sharedActionsConstantsLibrary.UPDATE_ALL_HISTORY:
      return {
        ...state,
        allHistoryUserId: action.data.userId,
        allHistory: action.data.payload || [],
      };
    default:
      return state;
  }
};
